module.exports = __webpack_public_path__ + "img/pic14.cfc2c7bb.png";